import Constant from '@/const';
import axios from 'axios';

const getDrugSalesById = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/drugssales/${id}`),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getDrugSalesById;
